import { TBannersList } from '@interfaces/advertising';
import { useAppSelector } from '@store/hooks/redux';
import { getBannersFromStateSelector, getIsLoadedBannersFromStateSelector } from '@store/selectors/advertising';

export const useBanners = (): TBannersList => useAppSelector(getBannersFromStateSelector);
export const useIsLoadedBanners = (): boolean => useAppSelector(getIsLoadedBannersFromStateSelector);
